/*
Author: Shivakumar
Date: 04/12/2019
Issue Description: [Onboarding V1.1][Salary Structure] Not able to create salary structure even after adding special allowance component.
search string: PL-1987
*/
/*
Author: Shivakumar
Date: 19/12/2019
Issue Description: After updating a salary structure by removing a component, not able get the updated salary structure.
search string: PL-2324
*/
/*
Author: Shivakumar
Date: 6/1/2020
Issue Description: If a statutory salary component is  part of CTC, it's mandatory to be a part of each salary structure or an warning message should be shown.
search string: PL-2356
*/


<template>
  <div class="create-new-structure">
    <div class="top-bar">
      <img @click="goBack" src="@/assets/path-2-copy.png" />
      <span class="heading_new">{{ heading }}</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="inner">
      <div class="applyfilter">
        <txt
          label="Salary Structure Name *"
          type="text"
          v-model="formData.name"
          name="salaryStructureName"
          data-vv-as="name"
          v-validate="{required: true, max: nameMaxlength}"
          :classname="errors.has('salaryStructureName')"
          :errormsg="errors.first('salaryStructureName')"
        />
        <txt
          label="Description"
          class="custom-width"
          maxlength="250"
          type="textarea"
          v-model="formData.description"
          name="salaryStructureDescription"
          data-vv-as="description"
          v-validate="{required: false, max: descriptionMaxlength}"
          :classname="errors.has('salaryStructureDescription')"
          :errormsg="errors.first('salaryStructureDescription')"
        />
      </div>
      <!-- <div class="row">
        <div class="col-12">
          <div class="heading">Address</div>
        </div>
      </div>
      <div class="filter">
        <tl-select
          name="salaryStructureCriteria"
          id="Criteria"
          label="Criteria"
          :placeholder="'Select'"
          labelText="name"
          :options="criteriaArray"
          v-model="formData.criteriaObj"
          @change="(val) => changeCriteria(val)"
        />
        <tl-select
          name="salaryStructureSubCriteria"
          id="SubCriteria"
          label="Sub Criteria"
          :placeholder="'Select'"
          labelText="name"
          :multiple="true"
          :options="subCriteriaArray"
          v-model="formData.subCriteriaObj"
          @change="(val) => changeSubCriteria(val)"
        />
      </div> -->
      <div class="alignLine">
        <p class="heading margintop-15">Select the Salary Components to add Salary Structure</p>
        <!-- <div class="row-container align-center margintop-15">
          <img src="@/assets/group-5.svg" class="Group-5" />
          <button class="text-green" @click="addNewComp()">Add New Component</button>
        </div> -->
      </div>
      <data-table
        :columns="columnNames"
        :tableData="partOfCTCsalaryComponents"
        :checkbox="true"
        :withForm="false"
        :showinheader="showinheader"
        :showedit="false"
        :search="search"
        :icons="[
                 {url:require('@/assets/garbage.png'), method: 'up'},
                 {url:require('@/assets/garbage.png'), method: 'down'},
                 {url:require('@/assets/garbage.png'), method: 'deletee'}
                 ]"
        :selectedRecord="activeData"
        @delete="deleteItem"
        @editStart="editItem"
        :showhistory="false"
        :showdelete="false"
        @selected="selected"
        @deselected="deselected"
        @headerSelection="headerCheckBoxChange"
      >
        <template v-slot:rowcontent="slotprops">
          <p
            v-if="slotprops.value.column.key == 'salary_component_type' && slotprops.value.record[slotprops.value.column.key] == 'FIXED'"
          >Fixed</p>
          <p
            v-if="slotprops.value.column.key == 'salary_component_type' && slotprops.value.record[slotprops.value.column.key] == 'VARIABLE'"
          >Variable</p>
          <p
          v-if="slotprops.value.column.key=='calculation' && slotprops.value.record[slotprops.value.column.key]"
          >{{ slotprops.value.record['calculation_type'] == 'SLAB' ? '--' : slotprops.value.record[slotprops.value.column.key][0]['formula'] ? slotprops.value.record[slotprops.value.column.key][0]['formula'] : '0' }}</p>
          <p
            v-if=" slotprops.value.column.key != 'SalaryComponentType' && slotprops.value.column.key != 'salary_component_type' && slotprops.value.column.key != 'calculation'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        </template>
      </data-table>
      <br />
      <div class="hidden">
        <txt label="FBP value" type="number" v-model="formData.value" name="name" />
      </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${formData.name} has been successfully ${editMode ? 'updated' : 'created'}`"
      btnText="Back to salary structure"
      @back="backfrompopup()"
    />
    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure you want to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmDelete()">Delete</button>
        </div>
      </template>
    </pop-up-message>
      <pop-up-message
      v-if="showConfirmFlag"
      :message="'Save Changes before procced !!'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="checkboxEvent()">OK</button>

        </div>
      </template>
    </pop-up-message>


    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="goBack" />
          <btn :text="buttonText" @click="save" type="primary" />
        </btn-grp>
      </template>
    </bottom-action-container>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import * as constants from "@/apis/constants.js";
import * as config from "@/apis/config.js";

export default {
  name: "CreateNewSalaryStructure",
  data: function() {
    return {
      partOfCTCsalaryComponents: [],
      popupType: "ConfirmDelete",
      currentObj: {},
      showConfirmDelete: false,
      criteriaArray: [],
      globalObj: null,
      subCriteriaArray: [],
      errmsg: "",
      showSuccessMsg: false,
      toast: false,
      showinheader: false,
      checkboxFlag: null,
      showConfirmFlag:false,
      search: "",
      buttonText: "Add Salary Structure",
      records: [],
      activeData: [],
      columnNames: [
        {
          label: "Component",
          key: "name"
        },
        {
          label: "Type",
          key: "salary_component_type"
        },
        {
          label: "Tax Exempt",
          key: "it_section"
        },
        {
          label: "Calculation type",
          key: "calculation_type"
        },
        {
          label: "Calculation",
          key: "calculation"
        }
      ],
      mappingobject: {
        sc_id: "",
        formula: "",
        effectiveDate: ""
      },
      isPfApplicable: false,
      formData: {
        criteriaObj: null,
        subCriteriaObj: null,
        name: "",
        description: "",
        le_id: "",
        mapping: [],
        rule: {},
        default: false
      },
      editMode: false,

      isPfEmployeeContributionPartOfCTC: false,
      isPfEmployerContributionPartOfCTC: false,
      nameMaxlength: null,
      descriptionMaxlength: null,
      defaultComponentCodes: ["Basic", "HRA", "DA", "ErPF", "SPL-ALW"]
    };
  },
  computed: {
    ...mapState({
      salaryComponentsData: state =>
        state.onboard.settings.salary_component.entityWiseData,
      salaryStructureData: state =>
        state.onboard.settings.salary_structure.entityWiseData,
      salaryStructureDetail: state =>
        state.onboard.settings.salary_structure.salaryStructureDetail,
      isCustom: state =>
        state.onboard.settings.salary_structure.isCustomStructure,
      unsavedEmployeeData: state => state.onboard.employees.unsavedEmployeeData,
      business_units: state => state.onboard.business_units.data,
      locations: state => state.onboard.locations.data,
      cost_centres: state => state.onboard.cost_centres.data,
      designations: state => state.onboard.designations.entityWiseData,
      empCategory: state => state.onboard.empCategory.data,
      salary_grades: state => state.onboard.salary_grades.data,
      salary_bands: state => state.onboard.salary_bands.data,
      employees: state => state.onboard.employees.entityWiseData,
      pf_settings: state => state.onboard.statutoryinfo.pfsettings.data
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    heading() {
      if (this.buttonText == "Add Salary Structure") {
        return "Create New Salary Structure";
      } else {
        return `Edit Salary Structure - ${this.formData.name}`;
      }
    }
  },

  mounted() {
    // try {
    //   this.setGlobalValidations();
    //   this.errmsg = "";
    //   this.toast = false;
    //   this.setConstantsData();
    //   this.fetchAllSalaryComponents();
    //   if (this.$route.query.id) {
    //     this.getSalaryStructureComponent();
    //     this.editMode = true;
    //     this.editDefaultSelection();
    //   } else {
    //     //Logic to set the default data
    //     this.buttonText = "Add Salary Structure";
    //     this.formData = {
    //       criteriaObj: "",
    //       name: "",
    //       description: "",
    //       le_id: "",
    //       mapping: [],
    //       rule: {},
    //       default: false
    //     };
    //     this.records = [];
    //     this.componentsData(true);
    //   }
    //
    //   if (this.pf_settings[this.leId]) {
    //     this.isPfApplicable = this.pf_settings[this.leId].isApplicable;
    //   }
    // } catch (err) {
    //   this.toast = true;
    //   this.errmsg = err;
    // }
  },
  activated() {
    try {
      this.setGlobalValidations();
      this.errmsg = "";
      this.toast = false;
      this.setConstantsData();
      this.fetchAllSalaryComponents();
      if (this.$route.query.id) {
        this.getSalaryStructureComponent();
        this.editMode = true;
        this.editDefaultSelection();
      } else {
        //Logic to set the default data
        this.buttonText = "Add Salary Structure";
        this.formData = {
          criteriaObj: "",
          name: "",
          description: "",
          le_id: "",
          mapping: [],
          rule: {},
          default: false
        };
        this.records = [];
        this.componentsData(true);
      }

      if (this.pf_settings[this.leId]) {
        this.isPfApplicable = this.pf_settings[this.leId].isApplicable;
      }
    } catch (err) {
      this.toast = true;
      this.errmsg = err;
    }
  },

  methods: {
    ...mapActions({
      act_delete: "onboard/settings/salary_component/delete",
      act_create: "onboard/settings/salary_structure/create",
      act_update: "onboard/settings/salary_structure/update",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchSalaryStructureComponent: "onboard/settings/salary_structure/fetchSalaryStructureComponents",
      act_flagCustomStructure: "onboard/settings/salary_structure/addCustomStructure",
      act_storeUnsavedEmployeeData: "onboard/employees/storeUnsavedEmployeeData",
      act_fetchAllSalaryComponents:
        "onboard/settings/salary_component/fetchAll",

      act_fetch_locations: "onboard/locations/fetchAll",
      act_fetch_salary_bands: "onboard/salary_bands/fetchAll",
      act_fetch_grades: "onboard/salary_grades/fetchAll",
      act_fetch_cost_centers: "onboard/cost_centres/fetchAll",
      act_fetch_business_units: "onboard/business_units/fetchAll",
      act_fetch_designations: "onboard/designations/fetchAll",
      act_fetch_employee_categories: "onboard/empCategory/fetchAll"
    }),
    /** Function to set form validations */
    setGlobalValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /*** Function to Set Constants Data for drop downs ***/
    setConstantsData() {
      try {
        this.criteriaArray = constants.SalaryStructureConstants.criteriaList;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Function to fetch components data from store */
    //PL-2324
    componentsData(setDefault) {
      try {
        this.partOfCTCsalaryComponents = [];
        let salaryComponents = this.salaryComponentsData[this.leId];

        if (salaryComponents) {
          if (salaryComponents.length) {
            salaryComponents.forEach((data, index) => {
              if (
                data.part_of_ctc ||
                this.records.some(salCompObj => salCompObj.id == data.id)
              ) {
                this.partOfCTCsalaryComponents.push(data);
              }
              if (data.part_of_ctc) {
                if (data.code == "EPF") {
                  this.isPfEmployeeContributionPartOfCTC = true;
                } else if (data.code == "ErPF") {
                  this.isPfEmployerContributionPartOfCTC = true;
                }
              }
              if (setDefault) {
                if (this.defaultComponentCodes.includes(data.code)) {
                  this.activeData.push(data);
                  this.records.push(data);
                }
              }
            });

          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    //PL-2324
    /** On click add new salary component */
    addNewComp() {
      try {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/addComponent`,
          params: {
            activeIndex: 3
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Function to fetch components of a salary structure from server */
    async getSalaryStructureComponent() {
      try {
        let res = await this.act_fetchSalaryStructureComponent({
          id: this.$route.query.id,
          leId: this.leId,
          type:'salarystructure'
        });
        if (res.message != null) {
          throw Error(res.message);
        }
        if (this.$route.query.id) {
          this.editDefaultSelection();
        }
        // this.salaryStructureDetail = res.data.payload[0];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Function to fetch Salary components from server */
    async fetchAllSalaryComponents() {
      try {
        let res = await this.act_fetchAllSalaryComponents(this.leId);
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On change of criteria drop down to fetch different sub-categories values */
    changeCriteria(event) {
      try {
        if (event) {
          this.subCriteriaArray = [];
          this.formData.criteriaObj = event;
          this.formData.subCriteriaObj = [];

          if (event.name == "Location") {
            this.subCriteriaArray = this.locations[this.leId]
              ? this.locations[this.leId]
              : [];
          } else if (event.name == "Cost Centre") {
            this.subCriteriaArray = this.cost_centres[this.leId]
              ? this.cost_centres[this.leId]
              : [];
          } else if (event.name == "Designations") {
            this.subCriteriaArray = this.designations[this.leId]
              ? this.designations[this.leId]
              : [];
          } else if (event.name == "Grade") {
            this.subCriteriaArray = this.salary_grades[this.leId]
              ? this.salary_grades[this.leId]
              : [];
          } else if (event.name == "Employee Category") {
            this.subCriteriaArray = this.empCategory ? this.empCategory : [];
          } else if (event.name == "Salary Band") {
            this.subCriteriaArray = this.salary_bands[this.leId]
              ? this.salary_bands[this.leId]
              : [];
          } else if (event.name == "BUs") {
            this.subCriteriaArray = this.business_units.data
              ? this.business_units.data
              : [];
          } /* else if (event.name == "Employee(s)") {
              this.subCriteriaArray = this.employees[this.leId]
                ? this.employees[this.leId]
                : [];
            }*/
          if (this.subCriteriaArray.length == 0) {
            this.getSubCriteriaList(event.name);
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getSubCriteriaList(eventName) {
      try {
        switch (eventName) {
          case "Location":
            this.getLocations();
            break;
          case "Salary Band":
            this.getSalaryBands();
            break;
          case "Grade":
            this.getGrades();
            break;
          case "Cost Center":
            this.getCostCenters();
            break;
          case "BUs":
            this.getBusinessUnits();
            break;
          case "Designations":
            this.getDesignations();
            break;
          case "Employee Category":
            this.getEmployeeCategories();
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch locations data from server */
    async getLocations() {
      try {
        await this.act_fetch_locations(this.leId);
        this.subCriteriaArray = this.locations[this.leId]
          ? this.locations[this.leId]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch  salary bands data from server */
    async getSalaryBands() {
      try {
        await this.act_fetch_salary_bands(this.leId);
        this.subCriteriaArray = this.salary_bands[this.leId]
          ? this.salary_bands[this.leId]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to grades data from server */
    async getGrades() {
      try {
        await this.act_fetch_grades(this.leId);
        this.subCriteriaArray = this.salary_grades[this.leId]
          ? this.salary_grades[this.leId]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to cost centers data from server */
    async getCostCenters() {
      try {
        await this.act_fetch_cost_centers(this.leId);
        this.subCriteriaArray = this.cost_centres[this.leId]
          ? this.cost_centres[this.leId]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to BU data from server */
    async getBusinessUnits() {
      try {
        await this.act_fetch_business_units(this.leId);
        this.subCriteriaArray = this.business_units.data
          ? this.business_units.data
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to designations data from server */
    async getDesignations() {
      try {
        await this.act_fetch_designations(this.leId);
        this.subCriteriaArray = this.designations[this.leId]
          ? this.designations[this.leId]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to employee categories data from server */
    async getEmployeeCategories() {
      try {
        await this.act_fetch_employee_categories(this.leId);
        this.subCriteriaArray = this.empCategory ? this.empCategory : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On sub criteria  drop down change  */
    changeSubCriteria(event) {
      if (event) {
        this.formData.subCriteriaObj = event;
      } else {
        this.formData.subCriteriaObj = null;
      }
    },
    /** Function to set data from server to populate in form */
    async editDefaultSelection() {
      try {
        // //console.log("this.salaryStructureData[this.leId] : ", this.salaryStructureData[this.leId]);
        // let obj = this.salaryStructureData[this.leId].find(
        //   item => item.id == this.$route.query.id
        // );
        let obj = this.salaryStructureDetail;
        this.globalObj = obj;
        //console.log(obj);
        //console.log("this.salaryStructureDetail : ", this.salaryStructureDetail);

        this.formData.name = obj.name;
        this.formData.description = obj.description;
        this.formData.le_id = obj.le_id;
        this.formData.id = obj.id;
        this.formData.sc_id = obj.sc_id;
        this.formData.default = obj.default;
        this.records = obj.sssc ? obj.sssc : [];

        // Newly added component in LE is shown in Salary structure edit
        let salaryComponents = this.salaryComponentsData[this.leId];

        if (salaryComponents) {
          if (salaryComponents.length) {
            salaryComponents.forEach((data, index) => {
              if ( data.part_of_ctc &&
                !(this.records.some(salCompObj => salCompObj.code == data.code ))) {
                this.records.push(data);
              }
            })
          }
        }

        this.partOfCTCsalaryComponents = this.records;

        this.buttonText = "Update";
        this.activeData = [];
        // this.records.forEach(element => {
        //   let obj = element;
        //   obj.id = element.sc_id;
        //   this.activeData.push(obj);
        // });
        this.activeData = this.$_.cloneDeep(this.records).filter(component => component.selected == true);
        if(this.activeData && this.activeData.length)
        {
           this.selected(this.activeData)
        }
      
        //console.log("this.activeData  : ", this.activeData);

        this.setCriteria(obj);
        if (obj.rule) {
          this.setSubCriteria(obj.rule.criteriaObj);
        } else {
          this.subCriteriaArray = [];
        }

        // Refresh Selected Components
        // this.componentsData(false);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To set criteria values */
    setCriteria(obj) {
      this.formData.criteriaObj = obj.rule ? obj.rule.criteriaObj : null;
    },
    /** To set sub criteria values based on certain conditions */
    setSubCriteria(obj) {
      try {
        if (obj) {
          if (obj.name == "Location") {
            this.subCriteriaArray = this.locations[this.leId]
              ? this.locations[this.leId]
              : [];
          } else if (obj.name == "Salary Band") {
            this.subCriteriaArray = this.salary_bands[this.leId]
              ? this.salary_bands[this.leId]
              : [];
          } else if (obj.name == "Grade") {
            this.subCriteriaArray = this.salary_grades[this.leId]
              ? this.salary_grades[this.leId]
              : [];
          } else if (obj.name == "Cost Center") {
            this.subCriteriaArray = this.cost_centres[this.leId]
              ? this.cost_centres[this.leId]
              : [];
          } else if (obj.name == "BUs") {
            this.subCriteriaArray = this.business_units[this.leId]
              ? this.business_units[this.leId]
              : [];
          } else if (obj.name == "Employee(s)") {
            this.subCriteriaArray = this.employees[this.leId]
              ? this.employees[this.leId]
              : [];
          }
        }
        this.formData.subCriteriaObj = this.globalObj.rule.subCriteriaObj
          ? this.globalObj.rule.subCriteriaObj
          : null;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On click of selection of checkbox in data table */
    selected(records, record) {
      try {
        //console.log("selected : ", records);
        // this.records = records.map(component => {
        // if (component.code == record.code) {
        //   component.selected = true;
        // }
        // });
        this.records = records;
        this.checkboxFlag ? this.checkboxFlag = false :this.checkboxFlag = true
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On click of de-selection of checkbox in data table */
    deselected(records, record) {
      try {
       //console.log("deselected : ", records);
       this.checkboxFlag ? this.checkboxFlag = false :this.checkboxFlag = true  ;
       // this.records = records.map(component => {
       // if (component.code == record.code) {
       //   component.selected = false;
       // }
       // });
       this.records = records;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On click selection/de-selection of data table header check box */
    headerCheckBoxChange(isChecked, records) {
      //console.log("headerCheckBoxChange : ", isChecked, records);
      if (isChecked) {
        //this.checkboxFlag = true;
        this.records = records;
      } else {
        this.records = [];
      }
    },
    navHandler(navType) {
      try {
        if (navType == "back") {
          this.$emit("stepNum", 0);
          this.$validator.reset();
        } else if (navType == "next") {
          this.$emit("stepNum", 2);
          this.$validator.reset();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    goBack() {
      this.refresh();
    },
    /** T reset the form data */
    refresh() {
      try {
        this.toast = false;
        this.formData = {
          criteriaObj: null,
          subCriteriaObj: null,
          name: "",
          description: "",
          le_id: "",
          mapping: [],
          rule: {}
        };
        this.records = [];
        this.activeData = [];
        this.subCriteriaArray = [];
        if(this.isCustom) {
          this.backToAddEmployee();
        } else {
          this.$router.go(-1);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async backToAddEmployee() {
      await this.act_flagCustomStructure(false);
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/employeeDashboard/addEmployee`
      });
    },
    /** Navigation to previous screen */
    backfrompopup() {
      try {
        this.showSuccessMsg = false;
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/preferences`
          //   params: {
          //     activeIndex: 4
          //   }
        });
        //this.$router.go(-1);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On click of delete item of a salary component */
    deleteItem(item) {
      try {
        this.showConfirmDelete = true;
        this.currentObj = item;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    cancelEvent() {
      this.showConfirmDelete = false;

    },
      checkboxEvent(){
        this.showConfirmFlag = false;
      },

    confirmDelete() {
      this.deleteEvent();
    },
    /** Function to delete a salary compoent from server */
    async deleteEvent() {
      try {
        let res = await this.act_delete(this.currentObj);
        if (res.status) {
          this.showConfirmDelete = false;
          for (let i = 0; i < this.records.length; i++) {
            let recordId = this.records[i].id;
            if (recordId == this.currentObj.id) {
              this.records.splice(i, 0);
              break;
            }
          }
        }
      } catch (err) {
        this.showConfirmDelete = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    // /** On click of edit of salary component */
    // async editItem(rec) {
    //   if(this.checkboxFlag != true){
    //   try {

    //     this.$router.push({
    //       path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/modifyComponent`,
    //       query: { id: rec.id }
    //     });
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    //   }else{
    //     this.showConfirmFlag = true
    //   }
    // },
    /** To validate the form */
    save() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.performAction();
          } else {
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async setCustomSalaryStructureInAddEmployee(res) {
      let empData = this.$_.cloneDeep(this.unsavedEmployeeData);
      empData.salary.salary_structure_id = res.data.payload.id;
      await this.act_storeUnsavedEmployeeData(empData);
    },

    /** Function to submit the form data to server */
    async performAction() {
      try {
        this.formData.le_id = this.leId;
        this.formData.name = this.formData.name.toString().trim();
        this.formData.mapping = [];

        /*** Code to check for Special allowance selection mandatory ***/

        if (!this.records.length) {
          this.toast = true;
          this.errmsg =
            "Special allowance selection is mandatory to create a salary structure.";
          return;
        } else if (this.records.length) {
          //Start PL-1987
          let isSpecialAllowanceSelected = this.records.some(
            item =>
              (item.code
                ? item.code
                : item.scle.code
                ? item.scle.code
                : null) == "SPL-ALW"
          );

          if (!isSpecialAllowanceSelected) {
            this.toast = true;
            this.errmsg =
              "Special allowance selection is mandatory to create a salary structure.";
            return;
          }
          //End PL-1987

          //Start PL-2356
          // if (this.isPfApplicable) {
          //   if (this.isPfEmployeeContributionPartOfCTC) {
          //     let isPfEmployeeContributionSelected = this.records.some(
          //       item =>
          //         (item.code
          //           ? item.code
          //           : item.scle.code
          //           ? item.scle.code
          //           : null) == "EPF"
          //     );
          //
          //     if (!isPfEmployeeContributionSelected) {
          //       this.toast = true;
          //       this.errmsg =
          //         "PF Employee Contribution is mandatory to create/update a salary structure.";
          //       return;
          //     }
          //   }
          //
          //   if (this.isPfEmployerContributionPartOfCTC) {
          //     let isPfEmployerContributionSelected = this.records.some(
          //       item =>
          //         (item.code
          //           ? item.code
          //           : item.scle.code
          //           ? item.scle.code
          //           : null) == "ErPF"
          //     );
          //
          //     if (!isPfEmployerContributionSelected) {
          //       this.toast = true;
          //       this.errmsg =
          //         "PF Employer Contribution is mandatory to create/update a salary structure.";
          //       return;
          //     }
          //   }
          // }
          //End PL-2356
        } else {
          this.toast = false;
          this.errmsg = "";
        }

        for (let i = 0; i < this.records.length; i++) {
          let recordObj = this.records[i];
          let obj = {};
          obj.sc_id = recordObj.id;

          if (recordObj.formula) {
            obj.formula = recordObj.formula;
          } else if (recordObj.calculation) {
            if (recordObj.calculation[0].formula) {
              obj.formula = recordObj.calculation[0].formula;
            } else {
              obj.formula = 0;
            }
          } else {
            obj.formula = null;
          }

          obj.effectiveDate = recordObj.effectiveDate
            ? recordObj.effectiveDate
            : recordObj.calculation
            ? recordObj.calculation[0].effective_date
              ? recordObj.calculation[0].effective_date
              : null
            : null;

          //Start PL-1987
          if (recordObj.code) {
            obj.code = recordObj.code;
          } else if (recordObj.scle) {
            obj.code = recordObj.scle.code ? recordObj.scle.code : null;
          } else {
            obj.code = null;
          }
          //obj.code = recordObj.code ? recordObj.code : recordObj.scle.code ? recordObj.scle.code : null;
          //End PL-1987

          this.formData.mapping.push(obj);
        }
        let subcriteriaArray = [];
        let selectedSubCriteriaArray = this.formData.subCriteriaObj;

        if (selectedSubCriteriaArray) {
          if (selectedSubCriteriaArray.length) {
            selectedSubCriteriaArray.forEach(item => {
              let obj = {
                id: item.id,
                name: item.name
              };
              subcriteriaArray.push(obj);
            });
          }
        }

        let ruleObj = {
          criteriaObj: this.formData.criteriaObj,
          subCriteriaObj: subcriteriaArray //this.formData.subCriteriaObj
        };
        this.formData.rule = ruleObj;

        let requestObj = {
          le_id: this.leId,
          name: this.formData.name.toString().trim(),
          description: this.formData.description,
          mapping: this.formData.mapping,
          rule: this.formData.rule,
          default: this.$route.query.id ? this.formData.default : false,
          id: this.$route.query.id ? this.formData.id : null
        };

        this.$root._data.isSaving = true;
        let res = null;
        if (!this.$route.query.id) {
          res = await this.act_create({ data: requestObj });
        } else {
          res = await this.act_update({ data: requestObj });
        }
        //console.log(res);
        this.showConfirmFlag = false;
        this.checkboxFlag = false;
        if (res.data.status) {
          this.showSuccessMsg = true;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
          if(this.isCustom) {
            this.showSuccessMsg = false;
            this.setCustomSalaryStructureInAddEmployee(res);
            this.backToAddEmployee();
          }
          this.getSalaryStructureComponent();
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.create-new-structure {
  width: 100%;
  margin-bottom: 200px;
}

.top-bar {
  height: 64px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}
.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
.heading {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  width: 100%;
}
.applyfilter {
  > div {
    flex-basis: 230px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
  .custom-width {
    width: 300px;
    height: 100px;
  }
}
.filter {
  display: flex;
  margin-right: 15px;
  > div {
    flex-basis: 230px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
  .custom-width {
    width: 212px;
    margin-top: 10px;
  }
}
.alignLine {
  display: flex;
}
.row-container {
  width: 26%;
}
</style>
